import { render, staticRenderFns } from "./VConfirmDialog.vue?vue&type=template&id=56137482&scoped=true&"
import script from "./VConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./VConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./VConfirmDialog.vue?vue&type=style&index=0&id=56137482&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56137482",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/myretro/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56137482')) {
      api.createRecord('56137482', component.options)
    } else {
      api.reload('56137482', component.options)
    }
    module.hot.accept("./VConfirmDialog.vue?vue&type=template&id=56137482&scoped=true&", function () {
      api.rerender('56137482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VConfirmDialog.vue"
export default component.exports